import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pdf-light-theme',
  templateUrl: './pdf-light-theme.component.html',
  styleUrls: ['./colors.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PdfLightThemeComponent {}
